import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../App/store";
import { Deposit } from "../components/Deposit/Deposit";
import Spinner from "../components/shared/Spinner/Spinner";
import ContractService from "../Services/ContractService";
import DataService from "../Services/DataService";
import ToastService from "../Services/ToastService";
import "./Profile.scss";
import { Withdraw } from "../components/Withdraw/Withdraw";
import moment from "moment";

interface RewardEntry {
  list: number;
  amount: number;
  root: string;
  is_claimable: boolean;
  is_distributed: boolean;
  created_at: string;
  rewards: {
    wallet: string;
    amount: number;
  }[];
}
export const Profile = () => {
  const [list, setList] = useState<RewardEntry[]>([]);
  // const [allList, setAllList] = useState<RewardEntry[]>();
  const userSelector = useSelector((state: RootState) => state.user);
  const [loading, setLoading] = useState<boolean>(false);
  const [claimedId, setClaimedId] = useState(-1);
  let loadingToast: string;

  useEffect(() => {
    DataService.cloud_function
      .myRewards()
      .then((res: any) => {
        setList(res.data.list.reverse() as RewardEntry[]);
        // if (res.data.all_list) {
        //   setAllList(res.data.all_list);
        // }
      })
      .catch();
  }, []);

  const handleClaim = async (item: RewardEntry, i: number) => {
    if (!item.is_claimable) return;
    if (item.is_claimable && !item.is_distributed) return;

    setClaimedId(i);
    try {
      await ContractService.setUpContract();

      const merkleTree = ContractService.createMerkleTree(item.rewards);

      let proof: any = ContractService.createProofData(
        userSelector.user.wallet as string,
        item.amount
      );
      proof = merkleTree.getHexProof(proof);

      const slimeShadiesSignerConnectedContract =
        await ContractService.getConnectedContract(
          ContractService.getSolidities().SlimeShadiesSolidity
        );

      await slimeShadiesSignerConnectedContract
        .claim(
          item.list,
          ContractService.parseEther(item.amount.toString()),
          proof
        )
        .then(() => {
          loadingToast = ToastService.loading(
            "Your request has been received. This process may take a few minutes."
          );
          startClaimEventListener();
        })
        .catch((error: any) => {
          setLoading(false);
          console.log("e1 :", error);
          ToastService.error(ContractService.handleErrorMessage(error));
        })
        .finally(() => setLoading(false));
    } catch (error) {
      setClaimedId(-1);
    }
  };

  const startClaimEventListener = () => {
    ContractService.getSolidities().SlimeShadiesSolidity.on(
      "Claimed",
      (player: string, id: string, amount: any) => {
        if (player.toLowerCase() == userSelector.user.wallet) {
          const claimedItemIndex = list.findIndex(
            (item) => item.list == Number(id)
          );
          list[claimedItemIndex].is_claimable = false;
          setList(JSON.parse(JSON.stringify(list)));

          ToastService.success("Claim successfully completed.", {
            id: loadingToast,
          });
          ContractService.getSolidities().SlimeShadiesSolidity.removeAllListeners(
            "Claimed"
          );
        }
      }
    );
  };

  // const handleDistribute = async (item: RewardEntry) => {
  //   setLoading(true);
  //   try {
  //     await ContractService.setUpContract();
  //     const slimeShadiesSignerConnectedContract =
  //       await ContractService.getConnectedContract(
  //         ContractService.getSolidities().SlimeShadiesSolidity
  //       );

  //     await slimeShadiesSignerConnectedContract
  //       .setRewardDistribution(item.list, item.root)
  //       .then(() => {
  //         loadingToast = ToastService.loading(
  //           "Your request has been received. This process may take a few minutes."
  //         );
  //         startDistributionCreateEventListener();
  //       })
  //       .catch((error: any) => {
  //         console.log("e2 :", error);
  //         setLoading(false);
  //         ToastService.error(ContractService.handleErrorMessage(error));
  //       })
  //       .finally(() => setLoading(false));
  //   } catch (error) {
  //     console.log("err :", error);
  //     setLoading(false);
  //   }
  // };

  // const startDistributionCreateEventListener = () => {
  //   ContractService.getSolidities().SlimeShadiesSolidity.on(
  //     "RewardDistributionCreated",
  //     (id: any, root: any) => {
  //       const ditributedItemIndex = (allList || []).findIndex(
  //         (item) => item.list == Number(id)
  //       );

  //       (allList || [])[ditributedItemIndex].is_distributed = true;

  //       setAllList(JSON.parse(JSON.stringify(allList)));

  //       ToastService.success("Reward Distribution successfully completed.", {
  //         id: loadingToast,
  //       });

  //       ContractService.getSolidities().SlimeShadiesSolidity.removeAllListeners(
  //         "RewardDistributionCreated"
  //       );
  //     }
  //   );
  // };

  // const createNewList = () => {
  //   DataService.cloud_function
  //     .createList()
  //     .then((response: any) => {
  //       console.log("response :", response);
  //       allList?.unshift(response.data);
  //       setAllList(JSON.parse(JSON.stringify(allList)));
  //     })
  //     .catch((e) =>
  //       ToastService.error(e.response.data.message, { duration: 5000 })
  //     );
  // };

  return (
    <div className="PageContainer">
      <div className="ProfilePage">
        <div className="balance">
          {userSelector.user.wallet}
          <div>
            <Deposit minPrice={0} />
            <Withdraw />
            <span className="material-symbols-outlined">
              account_balance_wallet
            </span>
            <div>{Number(userSelector.user.balance?.toFixed(5))} {userSelector.user.coin}</div>
          </div>
        </div>
        {/* {allList && (
          <section>
            <div className="section-header">
              <h1>List </h1>
              <button
                // disabled={allList.some((item) => !item.is_distributed)}
                onClick={createNewList}
              >
                Create New List
              </button>
            </div>
            <ul>
              <li>
                <div className="col">List ID</div>
                <div className="col"></div>
              </li>
              {allList.map((item) => (
                <li key={item.list}>
                  <div className="col">{item.list} </div>
                  <div className="col action">
                    {!item.is_distributed ? (
                      <button onClick={() => handleDistribute(item)}>
                        {loading ? (
                          <Spinner renderContent="Distribute"></Spinner>
                        ) : (
                          "Distribute"
                        )}
                      </button>
                    ) : (
                      "Distributed"
                    )}
                  </div>
                </li>
              ))}
            </ul>
          </section>
        )} */}
        <section>
          <div className="section-header">
            <h1>Rewards</h1>
          </div>
          <ul>
            <li>
              <div className="col">Date</div>
              <div className="col">Reward</div>
              <div className="col"></div>
            </li>
            {list.map((item, i) => (
              <li key={item.list}>
                <div className="col" title={moment(item.created_at).format('LLL')}>{moment(item.created_at).fromNow()}</div>
                <div className="col">{item.amount} {userSelector.user.coin}</div>
                <div className="col action">
                  {item.is_claimable ? (
                    item.is_distributed ? (
                      <button
                        onClick={() => handleClaim(item, i)}
                        disabled={claimedId == i}
                      >
                        {claimedId == i ? (
                          <Spinner renderContent="Claim"></Spinner>
                        ) : (
                          "Claim"
                        )}
                      </button>
                    ) : (
                      "Locked"
                    )
                  ) : (
                    "Claimed"
                  )}
                </div>
              </li>
            ))}
          </ul>
        </section>
      </div>
    </div>
  );
};
